var $=jQuery.noConflict();

// accessibility - skip to content
//----------------------------------
$(document).ready(function() {
    // bind a click event to the 'skip' link
    $(".skip").click(function(event) {

        // strip the leading hash and declare
        // the content we're skipping to
        var skipTo = "#" + this.href.split('#')[1];

        // Setting 'tabindex' to -1 takes an element out of normal 
        // tab flow but allows it to be focused via javascript
        $(skipTo).attr('tabindex', -1).on('blur focusout', function() {

            // when focus leaves this element, 
            // remove the tabindex attribute
            $(this).removeAttr('tabindex');

        }).focus(); // focus on the content container
    });
});

var location;

// add target=“_blank” and class for outgoing link
$( 'a' ).each(function() {
  if( location.hostname === this.hostname || !this.hostname.length ) {
      $(this).addClass('local');
  } else {
      $(this).addClass('external');
      $(this).attr("target", "_blank");
  }
});


// different style for mailto links
//----------------------------------
$('a[href^=\\mailto]').each(function() {
    $(this).addClass('email no-external-link');
    $(this).removeAttr('target'); // fix WP function - removes target _blank to emails
});
// different style for tel links
//----------------------------------
$('a[href^=\\tel]').each(function() {
    $(this).addClass('phone no-external-link');
    $(this).removeAttr('target'); // fix WP function - removes target _blank to emails
});
// different style for inner links
//----------------------------------
$('a[href^=\\#]').each(function() {
    $(this).addClass('anchor-link');
    $(this).removeClass('local');
});



// accessibility - add icon to external links
//----------------------------------
$("a[target='_blank']").each(function() {
    // $(this).addClass('external');
    // $(this).append(" <i class='fas fa-external-link-alt fa-xs' aria-hidden='true'></i><span class='show-for-sr'>Abre en nueva ventana</span>");
    // $(this).append('<svg class="icon white tiny" viewBox="0 0 30 30"><use xlink:href="#external"></use></svg><span class="show-for-sr">Abre en nueva ventana</span>');
    $(this).append('<svg class="icon tiny icon-external" viewBox="0 0 60 60"><use xlink:href="#external"></use></svg><span class="show-for-sr">Abre en nueva ventana</span>');
});

// download link
$("a[download]").each(function() {
    $(this).prepend('<svg class="icon tiny small" viewBox="0 0 60 60"><use xlink:href="#download"></use></svg><span class="show-for-sr">Descarga</span> ');
});


$(function() {
    $( "#mobileshare-btn" ).click(function() {
        //$( ".item__social-share" ).toggle();
        $('.single-social-share').addClass('show');
    });
});